import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import PanelJPCP from './PanelJPCP';
import PanelHMA from './PanelHMA';
import config from "../../config";
import Button from 'react-bootstrap/Button';
import "./PavementDesign.css";
import  PavementDesignType from "./PavementDesignType";
import asphaltImg from "../../img/Asphalt.PNG";
import concreteImg from "../../img/Concrete.PNG";
import MnR from "./MnR";
import DesignSpecification from "./DesignSpecificationType";
import { Alert, Col, Container, Form, Modal, Row, ProgressBar, ButtonGroup, ToggleButton } from "react-bootstrap";
import SideNav from '../SideNav/SideNav';
import useFormValidation from '../../hooks/useFormValidation';
import ValidationError from '../ValidationError/ValidationError';

const PavementDesign = () => {
    let { id } = useParams();
    let navigate = useNavigate();
    const { handleBlur, getFieldState, validateAll } = useFormValidation();
    // console.log(PavementDesignType);
    const [data, setData] = useState(PavementDesignType);
    const [data2, setData2] = useState(PavementDesignType);
    const [spec, setSpec] = useState(DesignSpecification);
    const [error, setError] = useState(null);
    const [errorPopupShow, setErrorPopupShow] = useState(false);
    const [validationErrorShow, setValidationErrorShow] = useState(false);

    const [progress, setProgress] = useState(0);
    const [showProgressBar, setShowProgressBar] = useState(false);

    const [unitSystem, setUnitSystem] = useState('imperial'); // 'imperial' or 'metric'
    const [showUnitToggle] = useState(true);

    // Mobile responsiveness state
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [activeDesign, setActiveDesign] = useState(1);

    // Handle window resize for responsive layout
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Helper to get surface type string (handles both object and string cases)
    const getSurfaceType = (surface, defaultValue = 'JPCP') => {
        if (!surface) return defaultValue;
        return typeof surface === 'object' ? surface.type : surface;
    };

    const conversionFactors = {
        // Length conversions
        in_to_mm: 25.4,
        in_to_cm: 2.54,
        ft_to_m: 0.3048,

        // Pressure/Strength conversions
        psi_to_MPa: 0.00689476,
        psi_to_kPa: 6.89476,
        pci_to_kN_m3: 271.447,

        // Mass conversions
        lb_to_kg: 0.453592,
        ton_to_kg: 907.185
    };

    const toggleUnitSystem = () => {
        setUnitSystem(prev => prev === 'imperial' ? 'metric' : 'imperial');
    };

    const convertLength = (value) => {
        const num = parseFloat(value);
        if (isNaN(num)) return 0; // fallback to avoid crashes
        return unitSystem === 'imperial' ? num : num * conversionFactors.in_to_mm;
    };

    const displayLengthUnit = () => {
        return unitSystem === 'imperial' ? 'in' : 'mm';
    };

    const convertPressure = (value) => {
        return unitSystem === 'imperial' ? value : value * conversionFactors.psi_to_MPa;
    };

    const displayPressureUnit = () => {
        return unitSystem === 'imperial' ? 'psi' : 'MPa';
    };

    const convertModulus = (value) => {
        return unitSystem === 'imperial' ? value : value * conversionFactors.pci_to_kN_m3;
    };

    const displayModulusUnit = () => {
        return unitSystem === 'imperial' ? 'pci' : 'kN/m³';
    };

    // get design's IDs
    // fetch design details from the API
    useEffect(() => {
        axios.get(`${config.apiUrl}/api/design/${id}/1`)
        .then(response => {
            setData(response.data);

            if(response.data.mnr[0].timing_min === null){

                let mnr_input = {
                    surface_type: response.data.design.surface.type || "JPCP",
                    climate_zone: response.data.experiment.climate_zone || 1,
                    functional_system: response.data.experiment.functional_system || "Interstate"
                }

                const params = new URLSearchParams(mnr_input).toString();

                axios.get(`${config.apiUrl}/api/design/mnr_schedule?${params}`)
                .then(response => {
                    console.log("DESIGN 1: JPCP");
                    console.log(response.data);
                    changeMnR(response.data);
                })
                .catch(error => {
                    setError(error.message);
                    handleErrorPopupShow();
                });
            }

        })
        .catch(error => {
            setError(error.message);
            handleErrorPopupShow();
        });
    }, [id]);

    useEffect(() => {
        axios.get(`${config.apiUrl}/api/design/${id}/2`)
        .then(response => {
            setData2(response.data);

            if(response.data.mnr[0].timing_min === null){
                let mnr_input = {
                surface_type: response.data.experiment.surface_type || "HMA",
                climate_zone: response.data.experiment.climate_zone || 1,
                functional_system: response.data.experiment.functional_system || "Interstate"
                }
                const params = new URLSearchParams(mnr_input).toString();

                axios.get(`${config.apiUrl}/api/design/mnr_schedule?${params}`)
                .then(response => {
                    console.log("DESIGN 2: HMA");
                    console.log(response.data);
                    changeMnR2(response.data);
                })
                .catch(error => {
                    setError(error.message);
                    handleErrorPopupShow();
                });
            }
        })
        .catch(error => {
            setError(error.message);
            handleErrorPopupShow();
        });
    }, [id]);

    useEffect(() => {
        axios.get(`${config.apiUrl}/api/experiment/${id}/spec`)
        .then(response => {
            setSpec(response.data);
        })
        .catch(error => {
            setError(error.message);
            handleErrorPopupShow();
        });
    }, [id]);

    function changeSurface(e){
        //const { name, value, type, checked } = e.target;
        const { value } = e.target;

        let mnr_input = {
            surface_type: value,
            climate_zone: data.experiment.climate_zone,
            functional_system: data.experiment.functional_system
        }
        const params = new URLSearchParams(mnr_input).toString();

        axios.get(`${config.apiUrl}/api/design/mnr_schedule?${params}`)
            .then(response => {
                changeMnR(response.data);
            })
            .catch(error => {
                setError(error.message);
                handleErrorPopupShow();
            });

        setData(prevData => {
            return {
                ...prevData,
                design: {
                    ...prevData.design,
                    surface: value,
                },
            }
        });
    };

    function changeBase(e){
        //const { name, value, type, checked } = e.target;
        const { value } = e.target;

        if(value === "Granular Base"){
            setData(prevData => {
                return {
                    ...prevData,
                    design: {
                        ...prevData.design,
                        base: value,
                    },
                    jpcpDesign: {
                        ...prevData.jpcpDesign,
                        baseResilientModulus: {
                            min: 10000,
                            max: 20000,
                            mean: 15000,
                            distribution: "Uniform"
                        },
                    }
                }
            });
        } else if(value === "Asphalt-Treated Base"){
            setData(prevData => {
                return {
                    ...prevData,
                    design: {
                        ...prevData.design,
                        base: value,
                    },
                    jpcpDesign: {
                        ...prevData.jpcpDesign,
                        baseResilientModulus: {
                            min: 10000,
                            max: 20000,
                            mean: 15000,
                            distribution: "Uniform"
                        },
                    }
                }
            });
        } else if(value === "Cement-Treated Base"){
            setData(prevData => {
                return {
                    ...prevData,
                    design: {
                        ...prevData.design,
                        base: value,
                    },
                    jpcpDesign: {
                        ...prevData.jpcpDesign,
                        baseResilientModulus: {
                            min: 4800000,
                            max: 10500000,
                            mean: 765000,
                            distribution: "Uniform"
                        },
                    }
                }
            });
        }
    };

    function changeSurface2(e){
        //const { name, value, type, checked } = e.target;
        const { value } = e.target;

        let mnr_input = {
            surface_type: value,
            climate_zone: data2.experiment.climate_zone,
            functional_system: data2.experiment.functional_system
        }
        const params = new URLSearchParams(mnr_input).toString();

        axios.get(`${config.apiUrl}/api/design/mnr_schedule?${params}`)
            .then(response => {
                changeMnR2(response.data);
            })
            .catch(error => {
                setError(error.message);
                handleErrorPopupShow();
            });

        setData2(prevData => {
            return {
                ...prevData,
                design: {
                    ...prevData.design,
                    surface: value,
                },
            }
        });
    };

    function changeBase2(e){
        //const { name, value, type, checked } = e.target;
        const { value } = e.target;

        if(value === "Granular Base"){
            setData2(prevData => {
                return {
                    ...prevData,
                    design: {
                        ...prevData.design,
                        base: value,
                    },
                    jpcpDesign: {
                        ...prevData.jpcpDesign,
                        baseResilientModulus: {
                            min: 10000,
                            max: 20000,
                            mean: 15000,
                            distribution: "Uniform"
                        },
                    }
                }
            });
        } else if(value === "Asphalt-Treated Base"){
            setData2(prevData => {
                return {
                    ...prevData,
                    design: {
                        ...prevData.design,
                        base: value,
                    },
                    jpcpDesign: {
                        ...prevData.jpcpDesign,
                        baseResilientModulus: {
                            min: 10000,
                            max: 20000,
                            mean: 15000,
                            distribution: "Uniform"
                        },
                    }
                }
            });
        } else if(value === "Cement-Treated Base"){
            setData2(prevData => {
                return {
                    ...prevData,
                    design: {
                        ...prevData.design,
                        base: value,
                    },
                    jpcpDesign: {
                        ...prevData.jpcpDesign,
                        baseResilientModulus: {
                            min: 4800000,
                            max: 10500000,
                            mean: 765000,
                            distribution: "Uniform"
                        },
                    }
                }
            });
        }
    };

    function changeMnR(mnr_data){

        const updatedMnr = mnr_data.map((item, index) => ({
            timing_min: item.timing_min,
            timing_max: item.timing_max,
            treatment_type: item.treatment,
            material_removal: item.removal,
            material_addition: item.addition,
        }));

        setData(prevData => {
            return {
                ...prevData,
                mnr: updatedMnr
            }
        });
    };

    function changeMnR2(mnr_data){

        // Transform the mnr_data array to match the structure in your model
        const updatedMnr = mnr_data.map((item, index) => ({
            timing_min: item.timing_min,
            timing_max: item.timing_max,
            treatment_type: item.treatment,
            material_removal: item.removal,
            material_addition: item.addition,
        }));

        setData2(prevData => {
            return {
                ...prevData,
                mnr: updatedMnr
            }
        });
    };

    function handleChange(e) {
        const { name, value, type, checked } = e.target;
        const inputValue = type === 'checkbox' ? checked : value;
        const nameParts = name.split('.');  // Split the name by dots to handle nested keys, e.g., 'user.name'

        setData(prevFormData => {
          // Function to recursively update nested objects
          const updateNestedObject = (obj, parts, value) => {
            const part = parts.shift();  // Get the next property name in the path
            if (parts.length > 0) {
              obj[part] = updateNestedObject(obj[part] || {}, parts, inputValue);
            } else {
              obj[part] = inputValue;  // Set the value for the last part of the path

              // Additional logic section
            //   if (part === 'customThickness') {

            //   }

            //   if (name === 'jpcpDesign.pccCompStrength.min' || name === 'jpcpDesign.pccCompStrength.max' || name === 'jpcpDesign.pccCompStrength.max') {

            //   } else if (name === 'jpcpDesign.pccModulesOfRupture.min' || name === 'jpcpDesign.pccModulesOfRupture.max' || name === 'jpcpDesign.pccModulesOfRupture.max')
            //     {
            //   }

            }
            return {...obj};
          };

          return updateNestedObject({...prevFormData}, nameParts, value);
        });
    }

    function handleChangeArray(e) {
        const { name, value } = e.target;
        const [arrayName, index, field] = name.match(/(\w+)\[(\d+)\]\.(\w+)/).slice(1);

        setData(prevData => ({
            ...prevData,
            [arrayName]: prevData[arrayName].map((item, idx) => idx === Number(index) ? {...item, [field]: value} : item)
        }));
    }

    function handleChangeArray2(e) {
        const { name, value } = e.target;
        const [arrayName, index, field] = name.match(/(\w+)\[(\d+)\]\.(\w+)/).slice(1);

        setData2(prevData => ({
            ...prevData,
            [arrayName]: prevData[arrayName].map((item, idx) => idx === Number(index) ? {...item, [field]: value} : item)
        }));
    }


    function handleChange2(e) {
        const { name, value, type, checked } = e.target;
        const nameParts = name.split('.');  // Split the name by dots to handle nested keys, e.g., 'user.name'

        setData2(prevFormData => {
          // Function to recursively update nested objects
          const updateNestedObject = (obj, parts, value) => {
            const part = parts.shift();  // Get the next property name in the path
            if (parts.length > 0) {
              obj[part] = updateNestedObject(obj[part] || {}, parts, value);
            } else {
              obj[part] = type === 'checkbox' ? checked : value;  // Set the value for the last part of the path
            }
            return {...obj};
          };

          return updateNestedObject({...prevFormData}, nameParts, value);
        });
    }

    const updateDesignSpec = (e) => {
        const { name, value } = e.target;
        setSpec(prevSpec => {
            return {
                ...prevSpec,
                [name]: value
            }
        });
    }

    const validateForm = () => {
        const fields = [
            { name: 'design_life', value: spec.design_life, type: 'number' },
            { name: 'number_of_iterations', value: spec.number_of_iterations, type: 'number' },
            { name: 'analysis_period', value: spec.analysis_period, type: 'number' },
            // Design 1 fields
            { name: 'design.surfaceThicknessMin', value: data.design.surfaceThicknessMin, type: 'numberGteZero' },
            { name: 'design.surfaceThicknessMax', value: data.design.surfaceThicknessMax, type: 'numberGteZero' },
            { name: 'design.baseThicknessMin', value: data.design.baseThicknessMin, type: 'numberGteZero' },
            { name: 'design.baseThicknessMax', value: data.design.baseThicknessMax, type: 'numberGteZero' },
            { name: 'design.dowelDiameterMin', value: data.design.dowelDiameterMin, type: 'numberGteZero' },
            { name: 'design.dowelDiameterMax', value: data.design.dowelDiameterMax, type: 'numberGteZero' },
            { name: 'design.kValueMin', value: data.design.kValueMin, type: 'numberGteZero' },
            { name: 'design.kValueMax', value: data.design.kValueMax, type: 'numberGteZero' },
            // Design 2 fields
            { name: 'design2.surfaceThicknessMin', value: data2.design.surfaceThicknessMin, type: 'numberGteZero' },
            { name: 'design2.surfaceThicknessMax', value: data2.design.surfaceThicknessMax, type: 'numberGteZero' },
            { name: 'design2.baseThicknessMin', value: data2.design.baseThicknessMin, type: 'numberGteZero' },
            { name: 'design2.baseThicknessMax', value: data2.design.baseThicknessMax, type: 'numberGteZero' },
            { name: 'design2.kValueMin', value: data2.design.kValueMin, type: 'numberGteZero' },
            { name: 'design2.kValueMax', value: data2.design.kValueMax, type: 'numberGteZero' },
        ];
        return validateAll(fields);
    };

    const areAllDesignFieldsZero = () => {
        return (
            (data.design.surfaceThicknessMin ?? 0) === 0 &&
            (data.design.surfaceThicknessMax ?? 0) === 0 &&
            (data.design.baseThicknessMin ?? 0) === 0 &&
            (data.design.baseThicknessMax ?? 0) === 0 &&
            (data.design.dowelDiameterMin ?? 0) === 0 &&
            (data.design.dowelDiameterMax ?? 0) === 0 &&
            (data.design.kValueMin ?? 0) === 0 &&
            (data.design.kValueMax ?? 0) === 0 &&
            (data2.design.surfaceThicknessMin ?? 0) === 0 &&
            (data2.design.surfaceThicknessMax ?? 0) === 0 &&
            (data2.design.baseThicknessMin ?? 0) === 0 &&
            (data2.design.baseThicknessMax ?? 0) === 0 &&
            (data2.design.kValueMin ?? 0) === 0 &&
            (data2.design.kValueMax ?? 0) === 0
        );
    };

    const handlePavementDesign = async () => {
        if (!validateForm()) {
            setValidationErrorShow(true);
            return;
        }
        setShowProgressBar(true);
        setProgress(0);


        let progressValue = 0;
        const interval = setInterval(() => {
            progressValue += 1;
            setProgress(progressValue);
        }, spec.number_of_iterations / 2); // Updates every 50ms for a smooth progress bar

        console.log(data);
        try {
            await axios.put(`${config.apiUrl}/api/design/${data.id}`, data);
            await axios.put(`${config.apiUrl}/api/design/${data2.id}`, data2)

            await runPavementDesign(id);

        } finally {
            clearInterval(interval);
            setProgress(100);
            setTimeout(() => setShowProgressBar(false), 1000); // Hide progress bar after reaching 100%
        }
    };

    const runPavementDesign = async (id) => {
        let specData = {
            design_specification: spec.design_specification,
            design_life: spec.design_life,
            number_of_iterations: spec.number_of_iterations,
            analysis_period: spec.analysis_period,
        };

        try {
            await axios.post(`${config.apiUrl}/api/experiment/${id}/spec`, specData);
            console.log("Design specification is set...");

            const response = await axios.post(`${config.apiUrl}/api/design/${id}/run`, data);

            console.log(response.data.design1);

            setData(prevData => {
                return {
                    ...prevData,
                    design: {
                        ...prevData.design,
                        surfaceThicknessMin: response.data.design1.surface_thickness.min,
                        surfaceThicknessMax: response.data.design1.surface_thickness.max,
                        surfaceThicknessMC: response.data.design1.surface_thickness.MC,
                        baseThicknessMin: response.data.design1.base_thickness.min,
                        baseThicknessMax: response.data.design1.base_thickness.max,
                        baseThicknessMC: response.data.design1.base_thickness.MC,
                        kValueMin: response.data.design1.k_value.min,
                        kValueMax: response.data.design1.k_value.max,
                        kValueMC: response.data.design1.k_value.MC,
                        dowelDiameterMin: response.data.design1.dowelDiameter.min,
                        dowelDiameterMax: response.data.design1.dowelDiameter.max,
                        dowelDiameterMC: response.data.design1.dowelDiameter.MC,
                    },
                };
            });

            setData2(prevData => {
                return {
                    ...prevData,
                    design: {
                        ...prevData.design,
                        surfaceThicknessMin: response.data.design2.surface_thickness.min,
                        surfaceThicknessMax: response.data.design2.surface_thickness.max,
                        surfaceThicknessMC: response.data.design2.surface_thickness.MC,
                        baseThicknessMin: response.data.design2.base_thickness.min,
                        baseThicknessMax: response.data.design2.base_thickness.max,
                        baseThicknessMC: response.data.design2.base_thickness.MC,
                        kValueMin: response.data.design2.k_value.min,
                        kValueMax: response.data.design2.k_value.max,
                        kValueMC: response.data.design2.k_value.MC,
                        dowelDiameterMin: response.data.design2.dowelDiameter.min,
                        dowelDiameterMax: response.data.design2.dowelDiameter.max,
                        dowelDiameterMC: response.data.design2.dowelDiameter.MC,
                    },
                };
            });
        } catch (error) {
            setError(error.message);
            handleErrorPopupShow();
        }
    };

    const runAnalysis = async () => {
        if (!validateForm()) {
            setValidationErrorShow(true);
            return;
        }
        setShowProgressBar(true);
        setProgress(0);

        let specData = {
            design_specification: spec.design_specification,
            design_life: spec.design_life,
            number_of_iterations: spec.number_of_iterations,
            analysis_period: spec.analysis_period,
        };

        let progressValue = 0;
        const interval = setInterval(() => {
            progressValue = Math.min(progressValue + 1, 90); // cap at 90%
            setProgress(progressValue);
        }, 100);

        try {
            // === Step 1: Save new specs and designs ===
            await axios.post(`${config.apiUrl}/api/experiment/${id}/spec`, specData);
            await axios.put(`${config.apiUrl}/api/design/${data.id}`, data);
            await axios.put(`${config.apiUrl}/api/design/${data2.id}`, data2);

            // --- Fetch last experiment to compare inputs ---
            const expRes = await axios.get(`${config.apiUrl}/api/experiment/${id}`);
            const lastInputs = expRes.data?.experiment || {};

            const inputsChanged =
                JSON.stringify(specData) !== JSON.stringify(lastInputs.specification) ||
                JSON.stringify(data) !== JSON.stringify(lastInputs.design1) ||
                JSON.stringify(data2) !== JSON.stringify(lastInputs.design2);

            console.log("Inputs changed?", inputsChanged);

            // === Step 2: Trigger new analysis (fire-and-forget, but timestamped) ===
            const runBuster = `${Date.now()}_${Math.random()}`; // unique param each run
            axios
                .put(`${config.apiUrl}/api/experiment/${id}/run?v=${runBuster}`, data, {
                    timeout: 10000, // short timeout so Axios won't hang 30+ s
                })
                .then(() => console.log("Run request sent; backend now computing..."))
                .catch((err) => console.warn("Run request disconnected:", err.message));

            // --- Step 3: Grace delay before polling ---
            await new Promise((res) => setTimeout(res, 5000)); // wait 5 s before polling


            // === Step 4: Poll for both designs ===
            let attempts = 0;
            const checkReport = setInterval(async () => {
                attempts += 1;
                try {
                    const cacheBuster1 = `${Date.now()}_${Math.random()}`;
                    const cacheBuster2 = `${Date.now()}_${Math.random()}`;

                    const [res1, res2] = await Promise.all([
                        axios.get(
                            `${config.apiUrl}/api/report/data/design1-co2eq/${id}?v=${cacheBuster1}`
                        ),
                        axios.get(
                            `${config.apiUrl}/api/report/data/design2-co2eq/${id}?v=${cacheBuster2}`
                        ),
                    ]);

                    const d1Ready =
                        res1.status === 200 && Array.isArray(res1.data.design1_co2eq);
                    const d2Ready =
                        res2.status === 200 && Array.isArray(res2.data.design2_co2eq);

                    if (d1Ready && d2Ready) {
                        clearInterval(checkReport);
                        clearInterval(interval);
                        setProgress(100);
                        setTimeout(() => {
                            setShowProgressBar(false);
                            completeAnalysis(); // navigate to Results
                        }, 800);
                    }
                } catch (e) {
                    console.log("Report not ready yet...");
                }

                // keep progress bar moving slowly
                if (progressValue < 95) {
                    progressValue = Math.min(progressValue + 0.5, 95);
                    setProgress(progressValue);
                }

                // safety stop
                if (attempts > 60) {
                    clearInterval(checkReport);
                    clearInterval(interval);
                    setProgress(100);
                    setTimeout(() => {
                        setShowProgressBar(false);
                        completeAnalysis();
                    }, 800);
                }
            }, 3000);
        } catch (error) {
            setError(error.message);
            handleErrorPopupShow();
        }
    };

    const completeAnalysis = () => {
        setTimeout(() => {
            navigate(`/report/${id}`);
        }, 1000);
    }

    const goToBasicContext = () => {
        setTimeout(() => {
            navigate(`/pavement-context-basic/${id}`);
        }, 100);
    }

    const goToDetailedContext = () => {
        setTimeout(() => {
            navigate(`/pavement-context-custom/${id}`);
        }, 100);
    }

    const goToPedegreeMatrix = () => {
        setTimeout(() => {
            navigate(`/pedegree-matrix/${id}?backref=pavement-design`);
        }, 100);
    }

    const goToConcreteEmbodiedEmission = () => {
        setTimeout(() => {
            navigate(`/concrete-embodied-emission/${id}?backref=pavement-design`);
        }, 100);
    }

    const goToAsphaltEmbodiedEmission = () => {
        setTimeout(() => {
            navigate(`/asphalt-embodied-emission/${id}?backref=pavement-design`);
        }, 100);
    }

    const goToResults = () => {
        setTimeout(() => {
            navigate(`/report/${id}`);
        }, 100);
    }

    const handleErrorPopupClose = () => setErrorPopupShow(false);
    const handleErrorPopupShow = () => setErrorPopupShow(true);

    return (
        <div className="pavement-design-page">
            <SideNav active="pavement-design" id={id} passed={["pavement-context-basic", "pavement-context-custom", "pedegree-matrix", "asphalt-embodied-emission", "concrete-embodied-emission"]}
                goToBasicContext={goToBasicContext}
                goToDetailedContext={goToDetailedContext}
                goToAsphaltEmbodiedEmission={goToAsphaltEmbodiedEmission}
                goToConcreteEmbodiedEmission={goToConcreteEmbodiedEmission}
                goToPedegreeMatrix={goToPedegreeMatrix}
                goToPavementDesign={() => { }}
                goToResults={goToResults}
            />
            <Container>
                {/* Mobile Design Tabs */}
                {isMobile && (
                    <Row>
                        <Col>
                            <div className="pd-design-tabs">
                                <button
                                    className={activeDesign === 1 ? 'active' : ''}
                                    onClick={() => setActiveDesign(1)}
                                >
                                    Design 1 ({getSurfaceType(data.design.surface, 'JPCP')})
                                </button>
                                <button
                                    className={activeDesign === 2 ? 'active' : ''}
                                    onClick={() => setActiveDesign(2)}
                                >
                                    Design 2 ({getSurfaceType(data2.design.surface, 'HMA')})
                                </button>
                            </div>
                        </Col>
                    </Row>
                )}

                {/* Design 1 Section */}
                <Row className={isMobile && activeDesign !== 1 ? 'd-none' : ''}>
                    <Col xl={7}>
                        <div className="pd-design-card">
                            <div className="pd-design-header">
                                <label>Design Name:</label>
                                <Form.Control
                                    type="text"
                                    size="sm"
                                    name="design.designTitle"
                                    id="design.designTitle"
                                    value={data.design.designTitle}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="pd-layer-section">
                                <div className="pd__top-table">
                                    <img className="pd__image" src={concreteImg} alt="Asphalt" />
                                    <table style={{width: "80%"}}>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td className="pd__label">Min.</td>
                                            <td className="pd__label">Max.</td>
                                        </tr>
                                        <tr>
                                            <td className="pd__label">Surface</td>
                                            <td>
                                                <Form.Select
                                                    size="sm"
                                                    className="pd-select-sm"
                                                    name="design.surface"
                                                    value={getSurfaceType(data.design.surface)}
                                                    onChange={changeSurface}>
                                                        <option value="JPCP">JPCP</option>
                                                        {/*<option value="HMA">HMA</option>*/}
                                                        {/* Temporary Solution*/}
                                                </Form.Select>
                                            </td>
                                            <td className="pd__label">Thickness ({displayLengthUnit()})</td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    disabled={!data.design.customThickness}
                                                    name="design.surfaceThicknessMin"
                                                    value={parseFloat((convertLength(data.design.surfaceThicknessMin ?? 0)).toFixed(2))}
                                                    onChange={(e) => handleChange({
                                                        target: {
                                                            name: "design.surfaceThicknessMin",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.in_to_mm
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design.surfaceThicknessMin', data.design.surfaceThicknessMin, 'numberGteZero')}
                                                    isInvalid={getFieldState('design.surfaceThicknessMin').isInvalid}
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    disabled={!data.design.customThickness}
                                                    name="design.surfaceThicknessMax"
                                                    value={parseFloat((convertLength(data.design.surfaceThicknessMax ?? 0)).toFixed(2))}
                                                    onChange={(e) => handleChange({
                                                        target: {
                                                            name: "design.surfaceThicknessMax",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.in_to_mm
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design.surfaceThicknessMax', data.design.surfaceThicknessMax, 'numberGteZero')}
                                                    isInvalid={getFieldState('design.surfaceThicknessMax').isInvalid}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="pd__label">Base</td>
                                            <td>
                                                <Form.Select
                                                    size="sm"
                                                    className="pd-select-sm"
                                                    name="design.base"
                                                    value={data.design.base}
                                                    onChange={changeBase}>
                                                        <option value="Granular Base">Granular Base</option>
                                                        <option value="Asphalt-Treated Base">Asphalt-Treated Base</option>
                                                        <option value="Cement-Treated Base">Cement-Treated Base</option>
                                                </Form.Select>
                                            </td>
                                            <td className="pd__label">Thickness ({displayLengthUnit()})</td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    disabled={!data.design.customThickness}
                                                    name="design.baseThicknessMin"
                                                    value={parseFloat((convertLength(data.design.baseThicknessMin ?? 0)).toFixed(2))}
                                                    onChange={(e) => handleChange({
                                                        target: {
                                                            name: "design.baseThicknessMin",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.in_to_mm
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design.baseThicknessMin', data.design.baseThicknessMin, 'numberGteZero')}
                                                    isInvalid={getFieldState('design.baseThicknessMin').isInvalid}
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    disabled={!data.design.customThickness}
                                                    name="design.baseThicknessMax"
                                                    value={parseFloat((convertLength(data.design.baseThicknessMax ?? 0)).toFixed(2))}
                                                    onChange={(e) => handleChange({
                                                        target: {
                                                            name: "design.baseThicknessMax",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.in_to_mm
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design.baseThicknessMax', data.design.baseThicknessMax, 'numberGteZero')}
                                                    isInvalid={getFieldState('design.baseThicknessMax').isInvalid}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="pd__label">Dowel Bar</td>
                                            <td>

                                            </td>
                                            <td className="pd__label">Dowel diameter ({displayLengthUnit()})</td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    name="design.dowelDiameterMin"
                                                    value={parseFloat((convertLength(Number(data.design.dowelDiameterMin ?? 2))).toFixed(2))}
                                                    disabled={!data.design.customThickness}
                                                    onChange={(e) => handleChange({
                                                        target: {
                                                            name: "design.dowelDiameterMin",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.in_to_mm
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design.dowelDiameterMin', data.design.dowelDiameterMin, 'numberGteZero')}
                                                    isInvalid={getFieldState('design.dowelDiameterMin').isInvalid}
                                                />

                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    name="design.dowelDiameterMax"
                                                    value={parseFloat((convertLength(Number(data.design.dowelDiameterMax ?? 2))).toFixed(2))}
                                                    disabled={!data.design.customThickness}
                                                    onChange={(e) => handleChange({
                                                        target: {
                                                            name: "design.dowelDiameterMax",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.in_to_mm
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design.dowelDiameterMax', data.design.dowelDiameterMax, 'numberGteZero')}
                                                    isInvalid={getFieldState('design.dowelDiameterMax').isInvalid}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="pd__label">Subgrade</td>
                                            <td>

                                            </td>
                                            <td className="pd__label">K-value ({displayModulusUnit()})</td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    name="design.kValueMin"
                                                    value={parseFloat((convertModulus(Number(data.design.kValueMin ?? 0))).toFixed(2))}
                                                    disabled={!data.design.customThickness}
                                                    onChange={(e) => handleChange({
                                                        target: {
                                                            name: "design.kValueMin",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.pci_to_kN_m3
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design.kValueMin', data.design.kValueMin, 'numberGteZero')}
                                                    isInvalid={getFieldState('design.kValueMin').isInvalid}
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    name="design.kValueMax"
                                                    value={parseFloat((convertModulus(Number(data.design.kValueMax ?? 0))).toFixed(2))}
                                                    disabled={!data.design.customThickness}
                                                    onChange={(e) => handleChange({
                                                        target: {
                                                            name: "design.kValueMax",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.pci_to_kN_m3
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design.kValueMax', data.design.kValueMax, 'numberGteZero')}
                                                    isInvalid={getFieldState('design.kValueMax').isInvalid}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td colSpan={3}>
                                                {getSurfaceType(data.design.surface) === 'JPCP' && (
                                                    <table>
                                                        <tr>
                                                            <td className="pd__label">PCC Comp. <br/>Strength ({displayPressureUnit()})</td>
                                                            <td>
                                                                <label className="switch">
                                                                    <input type="checkbox"
                                                                        name="design.usePhaseComponent"
                                                                        checked={data.design.usePhaseComponent}
                                                                        onChange={handleChange} />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </td>
                                                            <td className="pd__label">PCC Modules<br/>of Rupture ({displayPressureUnit()}): MR</td>
                                                        </tr>
                                                    </table>
                                                )}
                                            </td>

                                            <td className="pd__label">Custom Design</td>
                                            <td>
                                                <label class="switch">
                                                    <input type="checkbox"
                                                    name="design.customThickness"
                                                    checked={data.design.customThickness}
                                                    onChange={handleChange}/>
                                                    <span class="slider round"></span>
                                                </label>
                                            </td>
                                        </tr>
                                    </table>
                                    {areAllDesignFieldsZero() && (
                                        <Alert variant="info" className="mt-2">
                                            To populate min and max values, toggle "Custom Design" to enter values manually, or click "Run Design" to auto-calculate.
                                        </Alert>
                                    )}
                                </div>
                                <div className="pd__bottom-table">
                                    {getSurfaceType(data.design.surface) === 'JPCP' && (
                                        <PanelJPCP
                                            onDataChange={handleChange}
                                            data={data}
                                            unitSystem={unitSystem}
                                            convertPressure={convertPressure}
                                            displayPressureUnit={displayPressureUnit}
                                            convertModulus={convertModulus}
                                            displayModulusUnit={displayModulusUnit}
                                            convertLength={convertLength}
                                            displayLengthUnit={displayLengthUnit}
                                            handleBlur={handleBlur}
                                            getFieldState={getFieldState}
                                            fieldPrefix=""
                                        />
                                    )}

                                    {getSurfaceType(data.design.surface) === 'HMA' && (
                                        <PanelHMA
                                            onDataChange={handleChange}
                                            data={data}
                                            unitSystem={unitSystem}
                                            convertPressure={convertPressure}
                                            displayPressureUnit={displayPressureUnit}
                                            convertLength={convertLength}
                                            displayLengthUnit={displayLengthUnit}
                                            handleBlur={handleBlur}
                                            getFieldState={getFieldState}
                                            fieldPrefix=""
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xl={5}>
                        {/* Unit Toggle for Design 1 */}
                        {showUnitToggle && (
                            <div className="pd-unit-toggle">
                                <span className="pd-toggle-label">Unit Toggle</span>
                                <ButtonGroup size="sm">
                                    <ToggleButton
                                        id="unit-toggle-1"
                                        type="checkbox"
                                        variant={unitSystem === 'imperial' ? 'primary' : 'outline-primary'}
                                        checked={unitSystem === 'imperial'}
                                        onChange={toggleUnitSystem}
                                    >
                                        Imperial
                                    </ToggleButton>
                                    <ToggleButton
                                        id="unit-toggle-1-metric"
                                        type="checkbox"
                                        variant={unitSystem === 'metric' ? 'primary' : 'outline-primary'}
                                        checked={unitSystem === 'metric'}
                                        onChange={toggleUnitSystem}
                                    >
                                        Metric
                                    </ToggleButton>
                                </ButtonGroup>
                            </div>
                        )}

                        {/* M&R Schedule for Design 1 */}
                        <div className="pd-mnr-section">
                            <div className="pd-mnr-header">Maintenance and Rehabilitation (M&R) Schedule</div>
                            <div className="pd-mnr-table">
                                <MnR onDataChange={handleChangeArray} data={data} surface_type={getSurfaceType(data.design.surface)} handleBlur={handleBlur} getFieldState={getFieldState} fieldPrefix=""/>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Design 2 Section */}
                <Row className={isMobile && activeDesign !== 2 ? 'd-none' : ''}>
                    <Col xl={7}>
                        <div className="pd-design-card">
                            <div className="pd-design-header">
                                <label>Design Name:</label>
                                <Form.Control
                                    type="text"
                                    size="sm"
                                    name="design.designTitle"
                                    id="design2.designTitle"
                                    value={data2.design.designTitle}
                                    onChange={handleChange2}
                                />
                            </div>
                            <div className="pd-layer-section">
                                <div className="pd__top-table">
                                    <img className="pd__image" src={asphaltImg} alt="Asphalt" />
                                    <table style={{width: "80%"}}>
                                        <tr>
                                            <td colSpan={3}></td>
                                            <td className="pd__label">Min.</td>
                                            <td className="pd__label">Max.</td>
                                        </tr>
                                        <tr>
                                            <td className="pd__label">Surface</td>
                                            <td>
                                                <Form.Select
                                                    size="sm"
                                                    className="pd-select-sm"
                                                    name="design.surface"
                                                    value={getSurfaceType(data2.design.surface)}
                                                    onChange={changeSurface2}>
                                                        {/*<option value="JPCP">JPCP</option>*/}
                                                        {/* Temporary Solution*/}
                                                        <option value="HMA">HMA</option>
                                                </Form.Select>
                                            </td>
                                            <td className="pd__label">Thickness ({displayLengthUnit()})</td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    disabled={!data2.design.customThickness}
                                                    name="design.surfaceThicknessMin"
                                                    value={parseFloat((convertLength(data2.design.surfaceThicknessMin ?? 0)).toFixed(2))}
                                                    onChange={(e) => handleChange2({
                                                        target: {
                                                            name: "design.surfaceThicknessMin",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.in_to_mm
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design2.surfaceThicknessMin', data2.design.surfaceThicknessMin, 'numberGteZero')}
                                                    isInvalid={getFieldState('design2.surfaceThicknessMin').isInvalid}
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    disabled={!data2.design.customThickness}
                                                    name="design.surfaceThicknessMax"
                                                    value={parseFloat((convertLength(data2.design.surfaceThicknessMax ?? 0)).toFixed(2))}
                                                    onChange={(e) => handleChange2({
                                                        target: {
                                                            name: "design.surfaceThicknessMax",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.in_to_mm
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design2.surfaceThicknessMax', data2.design.surfaceThicknessMax, 'numberGteZero')}
                                                    isInvalid={getFieldState('design2.surfaceThicknessMax').isInvalid}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="pd__label">Base</td>
                                            <td>
                                                <Form.Select
                                                    size="sm"
                                                    className="pd-select-sm"
                                                    name="design.base"
                                                    value={data2.design.base}
                                                    onChange={changeBase2}>
                                                        <option value="Granular Base">Granular Base</option>
                                                        <option value="Asphalt-Treated Base">Asphalt-Treated Base</option>
                                                        <option value="Cement-Treated Base">Cement-Treated Base</option>
                                                </Form.Select>
                                            </td>
                                            <td className="pd__label">Thickness ({displayLengthUnit()})</td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    disabled={!data2.design.customThickness}
                                                    name="design.baseThicknessMin"
                                                    value={parseFloat((convertLength(data2.design.baseThicknessMin ?? 0)).toFixed(2))}
                                                    onChange={(e) => handleChange2({
                                                        target: {
                                                            name: "design.baseThicknessMin",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.in_to_mm
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design2.baseThicknessMin', data2.design.baseThicknessMin, 'numberGteZero')}
                                                    isInvalid={getFieldState('design2.baseThicknessMin').isInvalid}
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    disabled={!data2.design.customThickness}
                                                    name="design.baseThicknessMax"
                                                    value={parseFloat((convertLength(data2.design.baseThicknessMax ?? 0)).toFixed(2))}
                                                    onChange={(e) => handleChange2({
                                                        target: {
                                                            name: "design.baseThicknessMax",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.in_to_mm
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design2.baseThicknessMax', data2.design.baseThicknessMax, 'numberGteZero')}
                                                    isInvalid={getFieldState('design2.baseThicknessMax').isInvalid}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="pd__label">Subgrade</td>
                                            <td>

                                            </td>
                                            <td className="pd__label">K-value ({displayModulusUnit()})</td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    name="design.kValueMin"
                                                    value={parseFloat((convertModulus(Number(data2.design.kValueMin ?? 0))).toFixed(2))}
                                                    disabled={!data2.design.customThickness}
                                                    onChange={(e) => handleChange2({
                                                        target: {
                                                            name: "design.kValueMin",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.pci_to_kN_m3
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design2.kValueMin', data2.design.kValueMin, 'numberGteZero')}
                                                    isInvalid={getFieldState('design2.kValueMin').isInvalid}
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    size="sm"
                                                    className="pd-input-sm"
                                                    name="design.kValueMax"
                                                    value={parseFloat((convertModulus(Number(data2.design.kValueMax ?? 0))).toFixed(2))}
                                                    disabled={!data2.design.customThickness}
                                                    onChange={(e) => handleChange2({
                                                        target: {
                                                            name: "design.kValueMax",
                                                            value: unitSystem === 'imperial' ? e.target.value : e.target.value / conversionFactors.pci_to_kN_m3  // FIXED: was unitSystem
                                                        }
                                                    })}
                                                    onBlur={(e) => handleBlur('design2.kValueMax', data2.design.kValueMax, 'numberGteZero')}
                                                    isInvalid={getFieldState('design2.kValueMax').isInvalid}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td colSpan={3}>
                                            {getSurfaceType(data2.design.surface) === 'JPCP' && (
                                                <table>
                                                    <tr>
                                                        <td className="pd__label">PCC Comp. <br/>Strength ({displayPressureUnit()})</td>
                                                        <td>
                                                            <label class="switch">
                                                                <input  type="checkbox"
                                                                        name="design.usePhaseComponent"
                                                                        checked={data2.design.usePhaseComponent}
                                                                        onChange={handleChange2} />
                                                                <span class="slider round"></span>
                                                            </label>
                                                        </td>
                                                        <td className="pd__label">PCC Modules<br/>of Rupture ({displayPressureUnit()}): MR</td>
                                                    </tr>
                                                </table>
                                            )}

                                            </td>

                                            <td className="pd__label">Custom Design</td>
                                            <td>
                                                <label class="switch">
                                                    <input type="checkbox"
                                                    name="design.customThickness"
                                                    checked={data2.design.customThickness}
                                                    onChange={handleChange2}/>
                                                    <span class="slider round"></span>
                                                </label>
                                            </td>
                                        </tr>
                                    </table>
                                    {areAllDesignFieldsZero() && (
                                        <Alert variant="info" className="mt-2">
                                            To populate min and max values, toggle "Custom Design" to enter values manually, or click "Run Design" to auto-calculate.
                                        </Alert>
                                    )}
                                </div>
                                <div className="pd__bottom-table">
                                    {getSurfaceType(data2.design.surface) === 'JPCP' && (
                                        <PanelJPCP
                                            onDataChange={handleChange2}
                                            data={data2}
                                            unitSystem={unitSystem}
                                            convertPressure={convertPressure}
                                            displayPressureUnit={displayPressureUnit}
                                            convertModulus={convertModulus}
                                            displayModulusUnit={displayModulusUnit}
                                            convertLength={convertLength}
                                            displayLengthUnit={displayLengthUnit}
                                            handleBlur={handleBlur}
                                            getFieldState={getFieldState}
                                            fieldPrefix="design2."
                                        />
                                    )}

                                    {getSurfaceType(data2.design.surface) === 'HMA' && (
                                        <PanelHMA
                                            onDataChange={handleChange2}
                                            data={data2}
                                            unitSystem={unitSystem}
                                            convertPressure={convertPressure}
                                            displayPressureUnit={displayPressureUnit}
                                            convertLength={convertLength}
                                            displayLengthUnit={displayLengthUnit}
                                            handleBlur={handleBlur}
                                            getFieldState={getFieldState}
                                            fieldPrefix="design2."
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xl={5}>
                        {/* Unit Toggle for Design 2 */}
                        {showUnitToggle && (
                            <div className="pd-unit-toggle">
                                <span className="pd-toggle-label">Unit Toggle</span>
                                <ButtonGroup size="sm">
                                    <ToggleButton
                                        id="unit-toggle-2"
                                        type="checkbox"
                                        variant={unitSystem === 'imperial' ? 'primary' : 'outline-primary'}
                                        checked={unitSystem === 'imperial'}
                                        onChange={toggleUnitSystem}
                                    >
                                        Imperial
                                    </ToggleButton>
                                    <ToggleButton
                                        id="unit-toggle-2-metric"
                                        type="checkbox"
                                        variant={unitSystem === 'metric' ? 'primary' : 'outline-primary'}
                                        checked={unitSystem === 'metric'}
                                        onChange={toggleUnitSystem}
                                    >
                                        Metric
                                    </ToggleButton>
                                </ButtonGroup>
                            </div>
                        )}

                        {/* M&R Schedule for Design 2 */}
                        <div className="pd-mnr-section">
                            <div className="pd-mnr-header">Maintenance and Rehabilitation (M&R) Schedule</div>
                            <div className="pd-mnr-table">
                                <MnR onDataChange={handleChangeArray2} data={data2} surface_type={getSurfaceType(data2.design.surface)} handleBlur={handleBlur} getFieldState={getFieldState} fieldPrefix="design2."/>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Design Specification Section */}
                <Row>
                    <Col>
                        <div className="pd-spec-section">
                            <div className="pd-spec-grid">
                                <div className="pd-spec-field">
                                    <label>Design Specification</label>
                                    <Form.Select
                                        size="sm"
                                        name="design_specification"
                                        value={spec.design_specification}
                                        onChange={updateDesignSpec}>
                                            <option value="AASHTO1993">AASHTO1993</option>
                                            <option value="MEPDG">MEPDG</option>
                                    </Form.Select>
                                </div>
                                <div className="pd-spec-field">
                                    <label>Design Life (years)</label>
                                    <Form.Control
                                        type="number"
                                        size="sm"
                                        name="design_life"
                                        value={spec.design_life}
                                        onChange={updateDesignSpec}
                                        onBlur={(e) => handleBlur(e.target.name, e.target.value, 'number')}
                                        isInvalid={getFieldState('design_life').isInvalid}
                                    />
                                    <ValidationError message={getFieldState('design_life').errorMessage} />
                                </div>
                                <div className="pd-spec-field">
                                    <label>Number of Iterations</label>
                                    <Form.Control
                                        type="number"
                                        size="sm"
                                        name="number_of_iterations"
                                        value={spec.number_of_iterations}
                                        onChange={updateDesignSpec}
                                        onBlur={(e) => handleBlur(e.target.name, e.target.value, 'number')}
                                        isInvalid={getFieldState('number_of_iterations').isInvalid}
                                    />
                                    <ValidationError message={getFieldState('number_of_iterations').errorMessage} />
                                </div>
                                <div className="pd-spec-field">
                                    <label>Analysis Period</label>
                                    <Form.Control
                                        type="number"
                                        size="sm"
                                        name="analysis_period"
                                        value={spec.analysis_period}
                                        onChange={updateDesignSpec}
                                        onBlur={(e) => handleBlur(e.target.name, e.target.value, 'number')}
                                        isInvalid={getFieldState('analysis_period').isInvalid}
                                    />
                                    <ValidationError message={getFieldState('analysis_period').errorMessage} />
                                </div>
                            </div>

                            {/* Progress Bar */}
                            {showProgressBar && (
                                <div className="pd-progress-container">
                                    <ProgressBar animated now={progress} />
                                </div>
                            )}

                            {/* Action Buttons */}
                            <div className="pd-actions">
                                <Button variant="primary" onClick={handlePavementDesign}>Run Design</Button>
                                <Button
                                    variant="primary"
                                    disabled={!data.design.kValueMin || !data.design.kValueMax}
                                    onClick={runAnalysis}
                                >
                                    Run Pavement LCA & LCCA Analyses
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* <Row>
                    <div className="pcb__box-footer">
                        <Button variant="primary" href={`/pavement-context-basic/${id}`}>Back</Button>
                        <Button variant="primary" href={`/concrete-embodied-emission/${id}`}>Concrete Embodied Emission</Button>
                        <Button variant="primary" href={`/asphalt-embodied-emission/${id}`}>Asphalt Embodied Emission</Button>

                    </div>
                </Row> */}

                <Modal show={errorPopupShow} onHide={handleErrorPopupClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{error}</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleErrorPopupClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={validationErrorShow} onHide={() => setValidationErrorShow(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Validation Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Please fix the highlighted errors before continuing. All fields are required and number values must be greater than or equal to 0.</Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => setValidationErrorShow(false)}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>

            </Container>
        </div>
    );
};

export default PavementDesign;
